import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Container,
  Row,
  Col,
  Input,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import ReactModal from "react-modal";
import Swal from "sweetalert2";

const AñadirTecnico = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState("");
  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  useEffect(() => {
    const obtenerAreas = async () => {
      try {
        const response = await axios.get(
          "https://contratosback.azurewebsites.net/api/v1/ObtenerAreas",
        );
        setAreas(response.data);
      } catch (error) {
        console.error("Error al obtener las áreas:", error);
      }
    };

    obtenerAreas();
  }, []);

  useEffect(() => {
    if (selectedArea) {
      const obtenerUsuariosPorArea = async () => {
        try {
          const response = await axios.get(
            `https://contratosback.azurewebsites.net/api/v1/AprobadoresArea/${selectedArea}`,
          );
          setUsuarios(response.data);
        } catch (error) {
          console.error("Error al obtener los usuarios:", error);
        }
      };
      obtenerUsuariosPorArea();
    } else {
      setUsuarios([]);
    }
  }, [selectedArea]);

  const enviarDatos = async () => {
    setLoading(true);

    try {
      const response = await axios.put(
        `https://contratosback.azurewebsites.net/api/v1/ActualizaSolicitud/${props.id}/${selectedUsuario}`,
        {
          aprobacionTecnica: 1,
          idAreaSolicitante: selectedArea,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Respuesta del servidor:", response.data);

      await Swal.fire({
        icon: "success",
        title: "Datos enviados",
        text: response.data,
        timer: 2500,
        showConfirmButton: false,
        willOpen: zIndexFix,
      });

      window.location.reload("/");
    } catch (error) {
      console.error("Error al enviar los datos:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudieron enviar los datos.",
        willOpen: zIndexFix,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-lg"
        onClick={() => setIsOpen(true)}
        title="Añadir Aprobación Tecnica"
        style={{
          padding: "5px 5px",
          fontSize: "10px",
          border: "2px solid grey",
        }}
      >
        Aprobación Técnica
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Crear Institucion"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={() => setIsOpen(false)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",

            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        <Header />

        <Container className="mt--7" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardHeader className="border-0 text-center">
                  APROBACIÓN TECNICA
                  <hr />
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <label htmlFor="areaSelect">
                      Seleccione el área encargada
                    </label>
                    <Input
                      type="select"
                      id="areaSelect"
                      value={selectedArea}
                      onChange={(e) => setSelectedArea(e.target.value)}
                    >
                      <option value="">Seleccione</option>
                      {areas.map((area) => (
                        <option key={area.id} value={area.id}>
                          {area.nombreArea}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  {usuarios.length > 0 && (
                    <FormGroup>
                      <label htmlFor="usuarioSelect">
                        Seleccione un usuario
                      </label>
                      <Input
                        type="select"
                        id="usuarioSelect"
                        value={selectedUsuario}
                        onChange={(e) => setSelectedUsuario(e.target.value)}
                      >
                        <option value="">Seleccione</option>
                        {usuarios.map((usuario) => (
                          <option key={usuario.id} value={usuario.id}>
                            {usuario.nombre}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  )}

                  <button
                    className="btn btn-primary btn-user btn-block"
                    onClick={enviarDatos}
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" /> : "Confirmar"}
                  </button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default AñadirTecnico;
